module.exports = __webpack_public_path__ + "img/front buttons quantity.cb594f5a.png";